export enum ETipoRelatorioComissao {
    Recebimento = 1,
    Faturamento = 2,
}
